import { GridColumn as KendoReactGridColumn, GridColumnProps as KendoReactGridColumnProps } from '@progress/kendo-react-grid';
import React from 'react';

export interface GridColumnProps extends KendoReactGridColumnProps {
    canBeHidden?: boolean;
    minWidth?: number;
    lockedWhenHorizontalBarIsVisible?: boolean;
}

export const GridColumn = (props: GridColumnProps) => <KendoReactGridColumn {...props} />;

GridColumn.displayName = 'KendoReactGridColumn';
